<template v-cloak>
  <div class="filters__block" v-if="filters.choices.length > 0">
    <fieldset :aria-labelledby="`legend-${filters.type}`">
      <legend :id="`legend-${filters.type}`" v-html="filters.title" />

      <label v-for="(term, index) in filtersWithoutAdditional" :key="`${filters.type}-${term.value}`" class="filters__label" :class="{ hidden: index > maxVisible - 1 && !pressed }">
        <input
            type="checkbox"
            :name="`${filters.type}[]`"
            :value="term.value"
            :disabled="term.count === 0 && !isChecked(filters.type, term.value)"
            :checked="isChecked(filters.type, term.value)"
            @change="handleFilterChange(filters.type, term.value, $event)"

        />
        <span v-html="`${term.name} (${term.count})`" /><span class="sr-only" v-html="1 === term.count ? 'item' : 'items'" />
      </label>

      <button v-if="filters.choices.length > maxVisible"
              class="btn btn--tertiary"
              @click="updatePressed"
              :aria-expanded="pressed"
              :aria-controls="`additional-${filters.type}-filters`">
        <Icon :icon="!pressed ? 'plus' : 'minus'" />
        <span v-if="buttonLabel" v-html="buttonLabel"></span>
      </button>

      <div :id="`additional-${filters.type}-filters`" :hidden="!pressed" class="extra-terms">
        <label v-for="(term, index) in additionalFilters" :key="`${filters.type}-${term.value}`" class="filters__label" :class="{ hidden: index > maxVisible - 1 && !pressed }">
          <input
              type="checkbox"
              :name="`${filters.type}[]`"
              :value="term.value"
              :disabled="term.count === 0 && !isChecked(filters.type, term.value)"
              :checked="isChecked(filters.type, term.value)"
              @change="handleFilterChange(filters.type, term.value, $event)"

          />
          <span v-html="`${term.name} (${term.count})`" /><span class="sr-only" v-html="1 === term.count ? 'item' : 'items'" />
        </label>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { defineComponent, inject, ref, computed } from 'vue';
import Icon from './Icon.vue';

export default defineComponent( {
  name: 'Fieldset',
  components: {
    Icon,
  },
  props: {
    filters: {
      type: Object,
      default: () => ( {
        title: 'Tags',
        type: 'post_tag',
        choices: [],
      } ),
    },
  },
  setup( props, { emit } ) {
    // Reactive state for button pressed
    const pressed = ref( false );

    // Injected values
    const maxVisible = inject( 'amountVisibleFilters', 5 );
    const buttonLabels = inject( 'buttonLabels', { more: 'Show more', less: 'Show less' } );
    const selectedFilters = inject( 'selectedFilters' );

    // Computed property for button label based on pressed state.
    const buttonLabel = computed( () => ( pressed.value ? buttonLabels.less : buttonLabels.more ) );

    // Additional filters that are hidden by default.
    const additionalFilters = computed( () => {
      return props.filters.choices.filter( ( term, index ) => index > maxVisible - 1 );
    } );

    const filtersWithoutAdditional = computed( () => {
      return props.filters.choices.filter( ( term, index ) => index <= maxVisible - 1 );
    } );

    // Toggle pressed state.
    const updatePressed = (event) => {
      event.preventDefault();
      pressed.value = ! pressed.value;
    }

    const handleFilterChange = ( type, value, event ) => {
      const { checked } = event.target;

      emit( 'update:selectedFilters', { type, value, checked } );
    };

    /**
     * Returns boolean to check if the term is selected.
     *
     * @param {string} type The type.
     * @param {int|string} value The value.
     * @return {bool}
     */
    const isChecked = ( type, value ) => selectedFilters[ type ] && selectedFilters[ type ].includes( value );

    return {
      additionalFilters,
      filtersWithoutAdditional,
      updatePressed,
      buttonLabel,
      pressed,
      maxVisible,
      handleFilterChange,
      isChecked
    };
  },
} );
</script>
